/**
 * quillPatch.js — Patches de compatibilidade react-quill 2.x + React 18.
 *
 * Root cause do crash:
 *   No modo Strict do React 18, componentes montam → desmontam → remontam.
 *   Na segunda montagem, SnowTheme.buildPickers cria IconPicker para
 *   cada <select> do toolbar (ql-align, ql-header, ql-color, etc.).
 *   O constructor de IconPicker chama:
 *     this.defaultItem = this.container.querySelector('.ql-selected');
 *     this.selectItem(this.defaultItem, false);
 *   Se nenhum item tem .ql-selected, defaultItem = null → crash em null.innerHTML.
 *
 * Fix aplicado:
 *   Guarda null-safety no selectItem ANTES que qualquer ReactQuill monte.
 *   Este arquivo deve ser importado em index.js antes de App.
 *
 * @module quillPatch
 */
import Quill from 'quill';

try {
  const IconPicker = Quill.import('ui/icon-picker');

  if (IconPicker && IconPicker.prototype && typeof IconPicker.prototype.selectItem === 'function') {
    const originalSelectItem = IconPicker.prototype.selectItem;

    /**
     * Sobrescreve selectItem para ser null-safe.
     * Quill original não verifica se `item` é nulo antes de acessar innerHTML.
     */
    IconPicker.prototype.selectItem = function patchedSelectItem(item, trigger) {
      // Guard: item pode ser null quando nenhum picker-item tem .ql-selected
      // (situação que ocorre no double-mount do React 18 StrictMode)
      if (item == null) return;
      return originalSelectItem.call(this, item, trigger);
    };

    console.debug('[QuillPatch] IconPicker.selectItem patched for React 18 compatibility.');
  }
} catch (err) {
  // Falha silenciosa com aviso — o patch é opcional, não crítico
  console.warn('[QuillPatch] Nao foi possivel aplicar patch no IconPicker:', err.message);
}
